// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.Models\ChangeDetection\PilotJobOrderChange.cs
export enum PilotAssignmentChangeAction { 
    Add = 0,
    Remove = 10
}

export const PilotAssignmentChangeActionDisplayName : { [val : number] : string } = { 
    0: 'Add',
    10: 'Remove'
}

export const PilotAssignmentChangeActions : { Id : PilotAssignmentChangeAction, Name : string }[] = [ 
    { Id: PilotAssignmentChangeAction.Add, Name: 'Add' },
    { Id: PilotAssignmentChangeAction.Remove, Name: 'Remove' }
]



// WEBPACK FOOTER //
// ./server/enums/PilotJobOrderChange.ts